import dayjs from "dayjs";
import { FC } from "react";
import { defaultDateFormat } from "src/shared/constants/date.constants";
import { renderLabeledValues } from "src/shared/helpers/render.helpers";
import { ECountries } from "src/shared/types/common.types";
import { IPartnerDto } from "src/shared/types/partner.types";

interface IPartnerRegistrationDetailsProps {
  partner: IPartnerDto;
}

const PartnerRegistrationDetails: FC<IPartnerRegistrationDetailsProps> = ({
  partner,
}) => {
  const {
    registration_country,
    registration_number,
    ownership,
    name,
    okpo,
    kpp,
    ogrn,
    license,
    nonresident_phone,
    nonresident_email,
  } = partner;

  const isBelarus = registration_country.id === ECountries.BY;
  const isRussia = registration_country.id === ECountries.RU;
  const isOtherCountry =
    registration_country.id !== ECountries.BY &&
    registration_country.id !== ECountries.RU;

  const formatLicense = (license: string | undefined) =>
    license ? dayjs(license).format(defaultDateFormat) : "";

  return (
    <>
      {isBelarus && (
        <>
          {renderLabeledValues(
            [
              { label: "УНП", value: registration_number },
              { label: "Форма собственности", value: ownership.value },
              { label: "Наименование / ФИО", value: name },
              { label: "ОКПО", value: okpo },
              { label: "№ свидетельства", value: license?.number },
              {
                label: "Выдано",
                value: formatLicense(license?.issued_date),
              },
              {
                label: "Кем",
                value: license?.issued_by,
              },
            ],
            { breakValues: true },
          )}
        </>
      )}

      {isRussia && (
        <>
          {renderLabeledValues(
            [
              { label: "ИНН", value: registration_number },
              { label: "Форма собственности", value: ownership.value },
              { label: "Наименование / ФИО", value: name },
              { label: "ОКПО", value: okpo },
              { label: "КПП", value: kpp },
              { label: "ОГРН", value: ogrn },
              { label: "№ свидетельства", value: license?.number },
              {
                label: "Выдано",
                value: formatLicense(license?.issued_date),
              },
              {
                label: "Кем",
                value: license?.issued_by,
              },
            ],
            { breakValues: true },
          )}
        </>
      )}

      {isOtherCountry && (
        <>
          {renderLabeledValues(
            [
              {
                label: "Регистрационный номер",
                value: registration_number,
              },
              { label: "Форма собственности", value: ownership.value },
              { label: "Наименование / ФИО", value: name },
              { label: "Телефон", value: nonresident_phone },
              { label: "Email", value: nonresident_email },
            ],
            { breakValues: true },
          )}
        </>
      )}
    </>
  );
};

export default PartnerRegistrationDetails;
